import { useDispatch, useSelector } from '@/store/react-redux';
import { updateCommentHint } from '@/store/reducers/notification';
import { useCallback } from 'react';
import { clearCommentHint } from './api';

export default function useCommentHint() {
  const dispatch = useDispatch();
  const commentHint = useSelector(state => state.getIn(['notification', 'commentHint']));

  const updateHint = useCallback((hint: boolean) => {
    dispatch(updateCommentHint(hint));
  }, []);
  const clearHint = useCallback((point: string) => {
    clearCommentHint(point);
    dispatch(updateCommentHint(false));
  }, []);

  return { commentHint, updateCommentHint: updateHint, clearCommentHint: clearHint };
}
